import { Box } from "@mui/material";
import RowMenuListActions from "components/TableMonitoring/Body/RowMenuListActions";
import AssociateMenuOption from "components/TableMonitoring/Body/RowMenuListActions/AssociateMenuOption";
import DeleteMenuOption from "components/TableMonitoring/Body/RowMenuListActions/DeleteMenuOption";
import DuplicateMenuOption from "components/TableMonitoring/Body/RowMenuListActions/DuplicateMenuOption";
import EditMenuOption from "components/TableMonitoring/Body/RowMenuListActions/EditMenuOption";
import TableMonitoring from "components/TableMonitoring";
import ContentTableRows from "./ContentTableRows";
import TableRowStatic from "components/TableMonitoring/Body/TableRowStatic";
import { ContentFormsLabels, contentTexts } from "locale/es";
import Loader from "components/Loader/Loader";
import NoDataTableBody from "components/TableMonitoring/Body/NoDataTableBody";
import { Outlet } from "react-router-dom";
import { useFilter } from "hooks/useFilter";
import { useFilterContext } from "context/FilterContext";
import { useSelector } from "react-redux";
import { RolesManager } from "utils/RolesManager";
import useSortedData from "hooks/useSortedData";
import TableHeaderDynamic from "components/TableMonitoring/Header/Dynamic/TableHeaderDynamic";
import FilterTable from "components/TableMonitoring/Toolbar/Filter";

const tableHeaders = [
  {
    label: ContentFormsLabels.TITLE,
    value: 'title',
    id: 'title',
    isSortable: false,
    name: ContentFormsLabels.TITLE,
  },
  {
    label: ContentFormsLabels.LINK,
    name: ContentFormsLabels.LINK,
    value: 'link',
    id: 'link',
    isSortable: false,
  },
  {
    label: ContentFormsLabels.PACKAGE,
    name: ContentFormsLabels.PACKAGE,
    value: 'businessPackage',
    id: 'businessPackage',
    isSortable: true,
  },
  {
    label: ContentFormsLabels.CONTENT_TYPE,
    name: ContentFormsLabels.CONTENT_TYPE,
    value: 'contentType',
    id: 'contentType',
    isSortable: false,
  },
  {
    label: ContentFormsLabels.IMAGE,
    name: ContentFormsLabels.IMAGE,
    value: 'url',
    id: 'url',
    isSortable: false,
  },
  {
    label: ContentFormsLabels.LABEL,
    name: ContentFormsLabels.LABEL,
    value: 'label',
    id: 'label',
    isSortable: false,
  },
  {
    label: ContentFormsLabels.PACKAGE_LABEL,
    name: ContentFormsLabels.PACKAGE_LABEL,
    value: 'packageLabel',
    id: 'packageLabel',
    isSortable: true,
  },
  {
    label: ContentFormsLabels.ENABLED,
    name: ContentFormsLabels.ENABLED,
    value: 'enabled',
    id: 'enabled',
    isSortable: false,
  },
];


function ContentManagement({ entityId, contents, isComponentContent = false }) {
  const { data, loading, error } = contents;
  const { selectedFilter, searchTerm } = useFilterContext();
  
  const { user } = useSelector(state => state.userAuthentication)

  const { sortedData, sortColumn, sortDirection, handleRequestSort } = useSortedData(data, 'packageLabel', 'asc', false);

  const adaptedTableHeaders = tableHeaders.map((header) => header.name);

  const { filteredData } = useFilter(data, adaptedTableHeaders);

  if (loading) {
    return <Loader message={contentTexts.LOADING} pt={32} />;
  }

  return (
    <>
      <Box mt={4} sx={{ minWidth: "100%" }}>
      <FilterTable data={data} tableHeaders={tableHeaders} />
        <TableMonitoring
          tableHeader={
            <TableHeaderDynamic
              columns={tableHeaders}
              sortDirection={sortDirection}
              sortColumn={sortColumn}
              onSort={handleRequestSort}
              canCreate
              entity={{ id: entityId }}
            />

          }
        >
          {(!searchTerm ? sortedData : filteredData).map(
            (content) => {
              return (
                <TableRowStatic
                  key={content.id}
                  entity={content}
                  loaded={!loading}
                  actions={<RowMenuListActions>
                    <EditMenuOption showText entity={content} />
                    <DeleteMenuOption showText entityId={content.id} />
                    {!isComponentContent &&
                      user.centers.length > 1 && (
                        <DuplicateMenuOption
                          showText={!isComponentContent
                            ? contentTexts.ASSOCIATE_CENTERS
                            : contentTexts.ASSOCIATE_COMPONENT}
                          entity={content} />
                      )}
                    {!isComponentContent &&
                      RolesManager.userIsProfessional(user.roles) && (
                        <AssociateMenuOption showText entityId={content.id} />
                      )}
                  </RowMenuListActions>}
                >
                  <ContentTableRows content={content} />
                </TableRowStatic>
              );
            }
          )}
        </TableMonitoring>
        {data?.length === 0 && (
          <NoDataTableBody
            entity={entityId}
            noDataMessage={contentTexts.NO_DATA}
          />
        )}
        {data?.length > 0 && filteredData?.length === 0 && searchTerm && (
          <NoDataTableBody
            entity={entityId}
            noDataMessage={contentTexts.NO_DATA_FILTERS}
          />
        )}
      </Box>
      <Outlet />
    </>
  );
}

export default ContentManagement;
